module.exports = __webpack_public_path__ + "img/capa2.e6f3cd2b.jpeg";